import React from "react";

const Home = () =>{

    return(

    <div className="mb-20">
        <h1 className="sm:text-4xl text-2xl font-bold mt-6 text-gray-900">Welcome to my Blog!</h1>

        <p className="mx-auto leading-relaxed text-base mt-4 mb-4">The Marvel Cinematic Universe (MCU) is an American media franchise and shared universe centered on a series of superhero films produced by Marvel Studios. The films are based on characters that appear in American comic books published by Marvel Comics. The franchise also includes television series, short films, digital series, and literature. The shared universe, much like the original Marvel Universe in comic books, was established by crossing over common plot elements, settings, cast, and characters.</p>
    
        <p>The DC Universe (DCU) is the fictional shared universe where most stories in American comic book titles published by DC Comics take place. Superheroes such as Superman, Batman, Wonder Woman, Martian Manhunter, The Flash, Green Lantern, Aquaman, and Green Arrow are from this universe, as well as teams such as the Justice League and the Teen Titans. It also contains well-known supervillains such as the Joker, Lex Luthor, Catwoman, Deathstroke, Reverse-Flash, Black Manta, the Penguin, the Riddler, the Scarecrow, Ra’s al Ghul, Sinestro, Brainiac, and Darkseid. In context, the term "DC Universe" usually refers to the main DC continuity.</p>

    </div>
    );
};

export default Home;